import React from "react";
import PropTypes from "prop-types";

/**
 * Standardized pagination controls component for use across all list views
 */
const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
    // Don't render if only one page exists
    if (totalPages <= 1) return null;
    
    return (
        <div className="pagination-controls" style={{ 
            margin: '16px 0',
            display: 'flex',
            justifyContent: 'center',
            padding: '10px'
        }}>
            <button 
                onClick={() => onPageChange(currentPage - 1)} 
                disabled={currentPage === 1}
                style={{
                    padding: '8px 16px',
                    marginRight: '10px',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    backgroundColor: currentPage === 1 ? '#f0f0f0' : '#007bff',
                    color: currentPage === 1 ? '#888' : 'white',
                    border: 'none',
                    borderRadius: '4px'
                }}
            >
                Previous
            </button>
            <span style={{ margin: '0 16px', lineHeight: '36px' }}>
                Page {currentPage} of {totalPages}
            </span>
            <button 
                onClick={() => onPageChange(currentPage + 1)} 
                disabled={currentPage === totalPages}
                style={{
                    padding: '8px 16px',
                    marginLeft: '10px',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                    backgroundColor: currentPage === totalPages ? '#f0f0f0' : '#007bff',
                    color: currentPage === totalPages ? '#888' : 'white',
                    border: 'none',
                    borderRadius: '4px'
                }}
            >
                Next
            </button>
        </div>
    );
};

PaginationControls.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
};

export default PaginationControls;